import $, { get } from 'jquery';

export function PlayVideo(selector = '.js-play-video', loaderSelector = '#general-loader') {
  const $button = $(selector);
  let container = null;

  function ajaxResponse(response) {
    container.html(response.data.iframe);
  }

  function handleClick(e) {
    e.preventDefault();
    const $target = $(e.currentTarget);
    const url = $target.attr('href');
    container = $($target.data('container'));
    console.log(container);
    $target.addClass('animation-blink');

    get(teik.ajax_url, {
      action: 'teik_ytembed',
      url
    }, ajaxResponse);
  }

  $button.click(handleClick);
}